// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    overflowY: "scroll",
    width: "100%",
    flex: 1
  }
}), { index: 1 })